const currentUrl = new URL(window.location.href);
let clientId = currentUrl.searchParams.get('clientId');
let tenantId = currentUrl.searchParams.get('tid');

const config = {
	// initiateLoginEndpoint: process.env.REACT_APP_START_LOGIN_PAGE_URL,
	initiateLoginEndpoint: `${currentUrl.origin}/auth-start.html`,
	clientId: clientId ?? process.env.REACT_APP_CLIENT_ID,
	apiEndpoint: process.env.REACT_APP_FUNC_ENDPOINT,
	apiName: process.env.REACT_APP_FUNC_NAME,
	tenantId
};

export default config;
